import React from 'react';
import clsx from 'clsx';
import Marquee from 'react-fast-marquee';

import styles from '../styles.module.scss';
import customStyles from './Custom.module.scss';
import {Icon1, Icon2, Icon3, Icon4, Line1, Line2, Line3} from '../../../assets/icons/custom';

export const CustomisationCard = () => {
  return (
    <div className={customStyles.custom}>
      <div className={clsx(styles.label, styles.web)}>
        <div className={clsx(styles.labelInner, styles.web)}>WEB</div>
      </div>
      <h4 className={styles.title}>Deep Customisation</h4>
      <p className={styles.subTitle}>
        Fine-tune security to your exact specifications, ensuring a perfect fit for your unique
        community.
      </p>
      <div className={customStyles.block}>
        <div className={customStyles.icon}>
          <Icon1 />
          <Marquee speed={50} gradient={false} direction="right" className={customStyles.marquee}>
            <Line1 />
          </Marquee>
        </div>
        <div className={customStyles.icon}>
          <Icon2 />
          <Marquee speed={50} gradient={false} direction="right" className={customStyles.marquee}>
            <Line2 />
          </Marquee>
        </div>
        <div className={customStyles.icon}>
          <Icon3 />
          <Marquee speed={50} gradient={false} direction="right" className={customStyles.marquee}>
            <Line3 />
          </Marquee>
        </div>
        <div className={customStyles.icon}>
          <Icon4 />
        </div>
      </div>
    </div>
  );
};
